// Typed helpers for path construction

export const screenStatePath = (projectId: string, key: string): string =>
  `project:${projectId}.screenState.${key}`;

export const accountPath = (key: string): string => `account.${key}`;

export const pageMetaPath = (pageId: string, key: string): string =>
  `page:${pageId}.meta.${key}`;

export const componentPropsPath = (componentId: string, key: string): string =>
  `component:${componentId}.props.${key}`;
